var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"text","inputmode":"numeric","pattern":"\\s*\\d{2}.\\d{2}.\\d{4}\\s*"},domProps:{"value":_vm.value},on:{"input":_vm.clearError,"change":_vm.checkGermanDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }